import ErrorComponent from "components/ErrorComponent";
import ListingHeaderComponent from "components/ListingHeaderComponent";
import LoaderComponent from "components/LoaderComponent";
import TableComponent from "components/TableComponent";
import React, { useEffect, useState } from "react";
import AddEditLanguage from "./AddEditLanguage";
import { CallAPI } from "actions/General";
import { LanguagesTableHeaders, ModalButtons } from "./utils";
import { DefaultPaginationSize } from "config/config";
import PaginationComponent from "components/PaginationComponent";
import CustomModal from "components/CustomModal";

function Languages() {
  const [editObj, setEditObj] = useState(null);
  const [languages, setLanguages] = useState([]);
  const [loader, setLoader] = useState(false);
  const [loaderType, setLoaderType] = useState("");
  const [apiError, setApiError] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(DefaultPaginationSize);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalVariant, setModalVariant] = useState("");
  const [modalType, setModalType] = useState("");
  const [deactivatedId, setDeactivatedId] = useState("");
  const [deactivatedType, setDeactivatedType] = useState("");
  const getLanguagesList = async () => {
    const APIName = "GET_ALL_LANGUAGES";
    const APIBody = { page, pageSize: limit };
    setLoaderType("get_listing");
    const result = await CallAPI(
      APIName,
      APIBody,
      null,
      setLoader,
      setApiError,
      null
    );
    if (result.status) {
      console.log(result);
      setLanguages(result.data.languages);
      setTotalRecords(result.data.total);
    } else if (result.error === 403) {
      setIsModalOpen(true);
      setModalVariant("error");
      setModalType("listing403");
    }
  };
  useEffect(() => {
    getLanguagesList();
  }, [page, limit]);
  const addLanguage = () => setEditObj({});
  const closeModal = () => {
    setIsModalOpen(false);
    if (page === 1) getLanguagesList();
    else setPage(1);
    setEditObj(null);
  };
  const editLanguage = (data) => {
    setEditObj(data);
  };
  const deactivateLanguageConfirmation = async (id, is_active) => {
    setDeactivatedId(id);
    setDeactivatedType(!is_active);
    setIsModalOpen(true);
    setModalVariant("confirm");
    setModalType(is_active ? "confirmDelete" : "confirmActive");
  };
  const deactivateLanguage = async () => {
    setLoaderType("delete");
    let result = await CallAPI(
      "ACTIVATE_UN_ACTIVATE_LANGUAGE",
      { is_active: deactivatedType },
      deactivatedId,
      setLoader,
      setApiError,
      null
    );
    setLoaderType("");
    if (result.status) {
      getLanguagesList();
      setModalVariant("success");
      setModalType(!deactivatedType ? "recordDelete" : "recordActivated");
    } else {
      setModalVariant("error");
      setModalType("deletionError");
    }
  };
  const actionOnDeactivatedLanguage = () => {
    setIsModalOpen(true);
    setModalVariant("error");
    setModalType("deactivateActionError");
  };
  return (
    <>
      {loader && loaderType === "get_listing" && (
        <LoaderComponent classes={"mx-4"} />
      )}
      <div className="card mb-4">
        {apiError && <ErrorComponent text={apiError} variant="danger" />}
        <ListingHeaderComponent
          type={"languages_listing"}
          setDisplayType={() => {}}
          displayType={""}
          addItem={addLanguage}
        />
        <div className={"card-body py-4"}>
          <TableComponent
            data={languages}
            header={LanguagesTableHeaders}
            type="languages"
            props={{
              editLanguage,
              deactivateLanguageConfirmation,
              actionOnDeactivatedLanguage,
            }}
          />
        </div>
      </div>
      {editObj && (
        <AddEditLanguage
          editObj={editObj}
          setEditObj={setEditObj}
          actionPerformedSuccessfully={() => {
            setModalType(
              editObj && editObj.id ? "recordUpdated" : "recordCreated"
            );
            setModalVariant("success");
            setIsModalOpen(true);
          }}
        />
      )}
      <PaginationComponent
        totalPages={
          totalRecords ? Math.ceil(totalRecords / limit) : totalRecords
        }
        pageLimit={limit}
        setPageLimit={setLimit}
        setPage={setPage}
        currentPage={page}
      />
      {isModalOpen && (
        <CustomModal
          header={""}
          text={ModalButtons[modalType].text}
          buttons={ModalButtons[modalType].buttons}
          onClose={closeModal}
          variant={modalVariant}
          functionsList={{ closeModal, deactivateLanguage }}
        />
      )}
    </>
  );
}

export default Languages;
